import { useContext } from 'react';
import { CircleSubject as BaseCircleSubject } from '@visx/annotation';
import DataContext from "../../context/DataContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
/** AnnotationSubjectCircle which provides color from theme. */
export default function AnnotationCircleSubject(props) {
  const {
    theme
  } = useContext(DataContext);
  return /*#__PURE__*/_jsx(BaseCircleSubject, {
    stroke: theme?.axisStyles.x.bottom.axisLine.stroke,
    ...props
  });
}